import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = { class: "modal-header" };
const _hoisted_2 = { class: "modal-title" };
const _hoisted_3 = { class: "modal-body" };
const _hoisted_4 = { class: "product-info" };
const _hoisted_5 = { class: "product-image" };
const _hoisted_6 = ["src", "alt"];
const _hoisted_7 = { class: "product-details" };
const _hoisted_8 = { class: "product-name" };
const _hoisted_9 = { class: "product-description" };
const _hoisted_10 = { class: "supplement-type-title" };
const _hoisted_11 = { class: "supplements-grid" };
const _hoisted_12 = ["onClick"];
const _hoisted_13 = { class: "supplement-image" };
const _hoisted_14 = ["src", "alt"];
const _hoisted_15 = { class: "supplement-info" };
const _hoisted_16 = { class: "supplement-name" };
const _hoisted_17 = { class: "supplement-price" };
const _hoisted_18 = {
    key: 0,
    class: "supplement-quantity-controls"
};
const _hoisted_19 = ["onClick", "disabled"];
const _hoisted_20 = { class: "quantity-display" };
const _hoisted_21 = ["onClick"];
const _hoisted_22 = {
    key: 1,
    class: "supplement-total"
};
const _hoisted_23 = { class: "total-value" };
const _hoisted_24 = { class: "modal-footer" };
const _hoisted_25 = { class: "total-price" };
const _hoisted_26 = { class: "price-value" };
const _hoisted_27 = { class: "action-buttons" };
import { ref, computed, watch } from "vue";
import htmlToText from "@/utils/html-to-text";
import { useStore } from "vuex";
export default /*@__PURE__*/ _defineComponent({
    __name: 'BaseSupplementsModal',
    props: {
        product: {},
        selectedSize: {},
        visible: { type: Boolean }
    },
    emits: ["close", "add-to-cart"],
    setup(__props, { emit: __emit }) {
        const store = useStore();
        const props = __props;
        const emit = __emit;
        const selectedSupplements = ref({});
        const quantity = ref(1);
        const categoryName = computed(() => {
            return props.product?.category_name || "";
        });
        const supplementsBases = computed(() => {
            if (!props.product)
                return [];
            // Support multiple possible field names
            const supplements = props.product.supplementsBases ||
                props.product.supplementsBases ||
                props.product.supplementBase ||
                [];
            return Array.isArray(supplements) ? supplements : [];
        });
        const groupedSupplements = computed(() => {
            const groups = {};
            supplementsBases.value.forEach((supplement) => {
                const typeCode = supplement.supplementTypeCode || "other";
                if (!groups[typeCode]) {
                    groups[typeCode] = [];
                }
                groups[typeCode].push(supplement);
            });
            return groups;
        });
        const getTypeLabel = (typeCode) => {
            const labels = {
                fromage: "Fromages",
                sauce: "Sauces",
                viande: "Viandes",
                legume: "Légumes",
                boisson: "Boissons",
                other: "Autres",
            };
            return labels[typeCode] || typeCode;
        };
        const isSelected = (supplementId) => {
            return (selectedSupplements.value[supplementId] || 0) > 0;
        };
        const getQuantity = (supplementId) => {
            return selectedSupplements.value[supplementId] || 0;
        };
        const toggleSupplement = (supplement) => {
            const currentQty = selectedSupplements.value[supplement.id] || 0;
            if (currentQty > 0) {
                selectedSupplements.value[supplement.id] = 0;
            }
            else {
                selectedSupplements.value[supplement.id] = 1;
            }
        };
        const incrementQuantity = (supplementId) => {
            const currentQty = selectedSupplements.value[supplementId] || 0;
            selectedSupplements.value[supplementId] = currentQty + 1;
        };
        const decrementQuantity = (supplementId) => {
            const currentQty = selectedSupplements.value[supplementId] || 0;
            if (currentQty > 0) {
                selectedSupplements.value[supplementId] = currentQty - 1;
            }
        };
        const getSupplementPrice = (supplement) => {
            if (supplement.price_variations &&
                supplement.price_variations.length > 0) {
                return parseFloat(supplement.price_variations[0].price) || 0;
            }
            return 0;
        };
        const getTotalForSupplement = (supplement) => {
            const qty = getQuantity(supplement.id);
            const price = getSupplementPrice(supplement);
            return qty * price;
        };
        const formatPrice = (price) => `${price.toFixed(2)} CHF`;
        const calculateTotal = () => {
            if (!props.selectedSize)
                return 0;
            const isDelivery = store.getters["orderType/isDelivery"];
            const basePrice = isDelivery && props.selectedSize.priceLivraison
                ? parseFloat(props.selectedSize.priceLivraison) || 0
                : parseFloat(props.selectedSize.price) || 0;
            let supplementsTotal = 0;
            supplementsBases.value.forEach((supplement) => {
                const qty = getQuantity(supplement.id);
                if (qty > 0) {
                    supplementsTotal += getSupplementPrice(supplement) * qty;
                }
            });
            return (basePrice + supplementsTotal) * quantity.value;
        };
        const closeModal = () => {
            selectedSupplements.value = {};
            quantity.value = 1;
            emit("close");
        };
        const handleAddToCart = () => {
            if (!props.product || !props.selectedSize)
                return;
            const sizeWithOriginalPrices = {
                ...props.selectedSize,
                price: props.selectedSize.price,
                priceLivraison: props.selectedSize.priceLivraison,
            };
            const cartIngredients = (props.product.ingredients || []).map((ing) => ({
                id: ing.id,
                name: ing.name,
                extra_cost_price: ing.price || 0,
                quantity: ing.isDefault ? 1 : 0,
                isDefault: ing.isDefault,
                size: props.selectedSize?.name || props.selectedSize?.size || "",
            }));
            // Convert selected supplements to CartSupplement format
            const selectedCartSupplements = [];
            supplementsBases.value.forEach((supplement) => {
                const qty = getQuantity(supplement.id);
                if (qty > 0) {
                    selectedCartSupplements.push({
                        id: supplement.id,
                        name: supplement.name,
                        extra_cost_price: getSupplementPrice(supplement),
                        quantity: qty,
                        type: supplement.supplementTypeCode || "other",
                        size: "unique",
                    });
                }
            });
            const event = {
                product: props.product,
                size: sizeWithOriginalPrices,
                quantity: quantity.value,
                ingredients: cartIngredients,
                supplements: selectedCartSupplements,
                additionnal: [],
                notes: "",
            };
            emit("add-to-cart", event);
            closeModal();
        };
        watch(() => props.product, (newProduct) => {
            selectedSupplements.value = {};
            quantity.value = 1;
        }, { immediate: true });
        return (_ctx, _cache) => {
            return (__props.visible && __props.product)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "modal-overlay",
                    onClick: closeModal
                }, [
                    _createElementVNode("div", {
                        class: "modal-content",
                        onClick: _cache[0] || (_cache[0] = _withModifiers(() => { }, ["stop"]))
                    }, [
                        _createElementVNode("div", _hoisted_1, [
                            _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.$t('pos.customizeYour')) + " " + _toDisplayString(__props.product.category_name || categoryName.value), 1),
                            _createElementVNode("button", {
                                onClick: closeModal,
                                class: "close-button"
                            }, [...(_cache[1] || (_cache[1] = [
                                    _createElementVNode("i", { class: "fas fa-times" }, null, -1)
                                ]))])
                        ]),
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("div", _hoisted_4, [
                                _createElementVNode("div", _hoisted_5, [
                                    _createElementVNode("img", {
                                        src: __props.product.image || '/imgs/product-placeholder.jpg',
                                        alt: __props.product.name,
                                        class: "product-img"
                                    }, null, 8, _hoisted_6)
                                ]),
                                _createElementVNode("div", _hoisted_7, [
                                    _createElementVNode("h3", _hoisted_8, _toDisplayString(__props.product.name), 1),
                                    _createElementVNode("p", _hoisted_9, _toDisplayString(_unref(htmlToText)(__props.product.description || "")), 1)
                                ])
                            ]),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupedSupplements.value, (supplements, typeCode) => {
                                return (_openBlock(), _createElementBlock("div", {
                                    key: typeCode,
                                    class: "supplement-type-section"
                                }, [
                                    _createElementVNode("h4", _hoisted_10, _toDisplayString(getTypeLabel(typeCode)), 1),
                                    _createElementVNode("div", _hoisted_11, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(supplements, (supplement) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                                key: supplement.id,
                                                class: _normalizeClass(["supplement-mini-card", { selected: isSelected(supplement.id) }]),
                                                onClick: ($event) => (toggleSupplement(supplement))
                                            }, [
                                                _createElementVNode("div", _hoisted_13, [
                                                    _createElementVNode("img", {
                                                        src: supplement.image_url || '/imgs/product-placeholder.jpg',
                                                        alt: supplement.name,
                                                        class: "supplement-img"
                                                    }, null, 8, _hoisted_14)
                                                ]),
                                                _createElementVNode("div", _hoisted_15, [
                                                    _createElementVNode("span", _hoisted_16, _toDisplayString(supplement.name), 1),
                                                    _createElementVNode("span", _hoisted_17, _toDisplayString(formatPrice(getSupplementPrice(supplement))), 1)
                                                ]),
                                                (isSelected(supplement.id))
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                                        _createElementVNode("button", {
                                                            onClick: _withModifiers(($event) => (decrementQuantity(supplement.id)), ["stop"]),
                                                            class: "quantity-btn",
                                                            disabled: getQuantity(supplement.id) <= 0
                                                        }, " - ", 8, _hoisted_19),
                                                        _createElementVNode("span", _hoisted_20, _toDisplayString(getQuantity(supplement.id)), 1),
                                                        _createElementVNode("button", {
                                                            onClick: _withModifiers(($event) => (incrementQuantity(supplement.id)), ["stop"]),
                                                            class: "quantity-btn"
                                                        }, " + ", 8, _hoisted_21)
                                                    ]))
                                                    : _createCommentVNode("", true),
                                                (isSelected(supplement.id))
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                                        _cache[2] || (_cache[2] = _createElementVNode("span", { class: "total-label" }, "Total:", -1)),
                                                        _createElementVNode("span", _hoisted_23, _toDisplayString(formatPrice(getTotalForSupplement(supplement))), 1)
                                                    ]))
                                                    : _createCommentVNode("", true)
                                            ], 10, _hoisted_12));
                                        }), 128))
                                    ])
                                ]));
                            }), 128))
                        ]),
                        _createElementVNode("div", _hoisted_24, [
                            _createElementVNode("div", _hoisted_25, [
                                _cache[3] || (_cache[3] = _createElementVNode("span", { class: "price-label" }, "Total :", -1)),
                                _createElementVNode("span", _hoisted_26, _toDisplayString(formatPrice(calculateTotal())), 1)
                            ]),
                            _createElementVNode("div", _hoisted_27, [
                                _createElementVNode("button", {
                                    onClick: closeModal,
                                    class: "cancel-btn"
                                }, _toDisplayString(_ctx.$t('common.cancel')), 1),
                                _createElementVNode("button", {
                                    onClick: handleAddToCart,
                                    class: "add-to-cart-btn"
                                }, [
                                    _cache[4] || (_cache[4] = _createElementVNode("i", { class: "fas fa-shopping-cart" }, null, -1)),
                                    _createTextVNode(" " + _toDisplayString(_ctx.$t('pos.addToCart')), 1)
                                ])
                            ])
                        ])
                    ])
                ]))
                : _createCommentVNode("", true);
        };
    }
});
